// LUMINA · pages/vajra/admin/TemplesSection.jsx
// Phase 65: Staff temple management

import React, { useState, useEffect } from 'react';
import { API, GD, DG, CR, PANEL } from '../constants';
import { VajraInput, VajraBtn } from '../primitives';
import ImageUpload from '../../../components/ImageUpload';

const BLANK = {
  name_zh:"", name_en:"", tradition:"", lineage:"", location:"",
  address:"", description_zh:"", description_en:"", website:"", photo_url:"",
  offering_info_json:"", contact_info:"", primary_teacher_id:null, is_featured:false,
};

export default function TemplesSection({ token, headers, teacherList = [] }) {
  const [list, setList]       = useState([]);
  const [form, setForm]       = useState(BLANK);
  const [editId, setEditId]   = useState(null);
  const [msg, setMsg]         = useState("");

  useEffect(() => { load(); }, []);

  const load = () =>
    fetch(`${API}/vajra/temples?per_page=100`, { headers })
      .then(r => r.ok ? r.json() : { temples:[] })
      .then(d => setList(d.temples || []));

  const submit = async (e) => {
    e.preventDefault();
    let offering_info = null;
    try { if (form.offering_info_json.trim()) offering_info = JSON.parse(form.offering_info_json); } catch { setMsg("✗ offering_info JSON 格式错误"); return; }
    const payload = { ...form, offering_info, offering_info_json: undefined };
    delete payload.offering_info_json;
    const url = editId ? `${API}/vajra/staff/temples/${editId}` : `${API}/vajra/staff/temples`;
    const r = await fetch(url, { method: editId ? "PUT" : "POST", headers, body: JSON.stringify(payload) });
    if (r.ok) { setMsg(editId ? "✓ 已更新" : "✓ 已创建"); setForm(BLANK); setEditId(null); load(); }
    else { const d = await r.json(); setMsg("✗ " + (d.detail || "操作失败")); }
  };

  const startEdit = (t) => {
    setForm({
      name_zh: t.name_zh||"", name_en: t.name_en||"", tradition: t.tradition||"",
      lineage: t.lineage||"", location: t.location||"", address: t.address||"",
      description_zh: t.description_zh||"", description_en: t.description_en||"", website: t.website||"", photo_url: t.photo_url||"",
      offering_info_json: t.offering_info ? JSON.stringify(t.offering_info, null, 2) : "",
      contact_info: t.contact_info||"", primary_teacher_id: t.primary_teacher?.id || null,
      is_featured: t.is_featured||false,
    });
    setEditId(t.id);
  };

  const deactivate = async (id) => {
    if (!window.confirm("确认停用此寺院？")) return;
    const r = await fetch(`${API}/vajra/staff/temples/${id}`, { method:"DELETE", headers });
    if (r.ok) { setMsg("✓ 已停用"); load(); } else setMsg("✗ 操作失败");
  };

  const inputStyle = { width:"100%", padding:"8px 10px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:7, fontSize:13, background:"rgba(255,255,255,0.9)", boxSizing:"border-box" };

  return (
    <div style={{ background:PANEL, borderRadius:12, padding:"22px", border:`1px solid rgba(6,78,59,0.12)` }}>
      {msg && <div style={{ fontSize:13, padding:"8px 14px", borderRadius:8, marginBottom:16, background:msg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)", color:msg.startsWith("✓")?DG:CR }}>{msg}</div>}

      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:18 }}>
        <div style={{ fontSize:15, color:DG }}>{editId ? "编辑寺院" : "新建寺院"}</div>
        {editId && <VajraBtn small variant="outline" onClick={()=>{ setEditId(null); setForm(BLANK); }}>取消</VajraBtn>}
      </div>

      <form onSubmit={submit}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
          <VajraInput label="寺院名称 *" value={form.name_zh} onChange={v=>setForm({...form,name_zh:v})} placeholder="如：噶托寺" required/>
          <VajraInput label="英文名（选填）" value={form.name_en} onChange={v=>setForm({...form,name_en:v})} placeholder="Kathog Monastery"/>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
          <div>
            <label style={{ fontSize:11, color:"#aaa", letterSpacing:1.2, textTransform:"uppercase", display:"block", marginBottom:5 }}>传承</label>
            <select value={form.tradition} onChange={e=>setForm({...form,tradition:e.target.value})} style={{...inputStyle}}>
              <option value="">-- 选择传承 --</option>
              {["噶举","宁玛","格鲁","萨迦","汉传","南传","其他"].map(t=><option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <VajraInput label="支派（选填）" value={form.lineage} onChange={v=>setForm({...form,lineage:v})} placeholder="止贡/白玉/…"/>
          <VajraInput label="所在地" value={form.location} onChange={v=>setForm({...form,location:v})} placeholder="印度·达兰萨拉"/>
        </div>
        <VajraInput label="地址（选填）" value={form.address} onChange={v=>setForm({...form,address:v})} placeholder="完整邮寄地址"/>
        <VajraInput label="官网（选填）" value={form.website} onChange={v=>setForm({...form,website:v})} placeholder="https://…"/>
        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 11, color: "#aaa", letterSpacing: 1.2, textTransform: "uppercase", display: "block", marginBottom: 6 }}>封面图</label>
          <ImageUpload
            currentUrl={form.photo_url}
            onUpload={(url) => setForm({ ...form, photo_url: url })}
            label="上传寺院封面图"
          />
          {form.photo_url && (
            <input value={form.photo_url} onChange={e => setForm({ ...form, photo_url: e.target.value })}
              placeholder="或直接输入图片URL" style={{ ...inputStyle, marginTop: 6, fontSize: 11, color: '#888' }} />
          )}
        </div>
        <div style={{ marginBottom:10 }}>
          <label style={{ fontSize:11, color:"#aaa", letterSpacing:1.2, textTransform:"uppercase", display:"block", marginBottom:5 }}>简介 DESCRIPTION</label>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            <textarea value={form.description_zh} onChange={e=>setForm({...form,description_zh:e.target.value})} rows={3} placeholder="寺院简介（中文）…" style={{...inputStyle, resize:"vertical"}}/>
            <textarea value={form.description_en} onChange={e=>setForm({...form,description_en:e.target.value})} rows={3} placeholder="Temple description (English)…" style={{...inputStyle, resize:"vertical"}}/>
          </div>
        </div>
        <div style={{ marginBottom:10 }}>
          <label style={{ fontSize:11, color:"#aaa", letterSpacing:1.2, textTransform:"uppercase", display:"block", marginBottom:5 }}>供养方式 JSON</label>
          <textarea value={form.offering_info_json} onChange={e=>setForm({...form,offering_info_json:e.target.value})} rows={3}
            placeholder={'{"etransfer":"temple@email.com","notes":"备注信息"}'}
            style={{...inputStyle, resize:"vertical", fontFamily:"monospace"}}/>
        </div>
        <VajraInput label="联系方式（选填）" value={form.contact_info} onChange={v=>setForm({...form,contact_info:v})} placeholder="电话 / 邮箱 / 微信"/>
        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:11, color:"#aaa", letterSpacing:1.2, textTransform:"uppercase", display:"block", marginBottom:5 }}>关联主法上师</label>
          <select value={form.primary_teacher_id||""} onChange={e=>setForm({...form,primary_teacher_id:e.target.value?parseInt(e.target.value):null})} style={{...inputStyle}}>
            <option value="">-- 选择上师（选填）--</option>
            {teacherList.map(t=><option key={t.id} value={t.id}>{t.name_zh}{t.name_en?` / ${t.name_en}`:""}</option>)}
          </select>
        </div>
        <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, color:"#555", cursor:"pointer", marginBottom:14 }}>
          <input type="checkbox" checked={form.is_featured} onChange={e=>setForm({...form,is_featured:e.target.checked})}/>
          精选推荐（首页显示）
        </label>
        <VajraBtn variant="green" type="submit">{editId ? "保存修改" : "创建寺院"}</VajraBtn>
      </form>

      {/* Temple list */}
      {list.length > 0 && (
        <div style={{ marginTop:24 }}>
          <div style={{ fontSize:12, color:"#aaa", letterSpacing:1.2, textTransform:"uppercase", marginBottom:10 }}>寺院列表 ({list.length})</div>
          {list.map(t=>(
            <div key={t.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"9px 12px", borderRadius:8, background:"rgba(0,0,0,0.02)", border:"1px solid rgba(0,0,0,0.06)", marginBottom:6 }}>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color:"#333" }}>{t.name_zh}{t.is_featured&&<span style={{ fontSize:10, marginLeft:6, background:"rgba(212,175,55,0.15)", color:"#8B6914", padding:"1px 6px", borderRadius:8 }}>精选</span>}</div>
                <div style={{ fontSize:11, color:"#999" }}>{t.tradition||"未分类"} · {t.location||"地点未定"}</div>
              </div>
              <div style={{ display:"flex", gap:6 }}>
                <VajraBtn small variant="outline" onClick={()=>startEdit(t)}>编辑</VajraBtn>
                <VajraBtn small variant="outline" onClick={()=>deactivate(t.id)} style={{ color:CR, borderColor:CR }}>停用</VajraBtn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
